import { useMemo } from 'react';
import { getStandaloneReturnUri } from 'Utilities/standaloneFlow';
import { store } from 'Utilities/store';
import partnersConfig from '../config/partnersConfig';
import useCommercialApiAuth from './partners/commercialapi/useCommercialApiAuth';
import useInsuletAuth from './partners/insulet/useInsuletAuth';
import useInsuletError from './partners/insulet/useInsuletError';
import useAuth from './useAuth';
import useDefaultError from './useDefaultError';
import useStandaloneAuth from './useStandaloneAuth';
const hookByApp = {
  insulet: {
    useAuth: useInsuletAuth,
    useError: useInsuletError
  },
  commercialapi: {
    useAuth: useCommercialApiAuth,
    useError: useDefaultError
  },
  default: {
    useAuth: useAuth,
    useError: useDefaultError
  }
};
const getDisplayActionBarHeader = (app, standaloneReturnUri) => {
  if (standaloneReturnUri) {
    return false;
  }
  return partnersConfig[app]?.displayActionBarHeader ?? false;
};
const usePartner = () => {
  const {
    env,
    nav: {
      location
    },
    config: {
      partners
    }
  } = store.getState();
  const {
    app,
    pId,
    registration_return_uri
  } = env;
  const standaloneReturnUri = getStandaloneReturnUri(env);
  // The shared parameter applies to registration and forgot password, not password reset.
  // Preserve reset behavior for callers using the legacy registration parameter.
  const isStandalone = !!standaloneReturnUri && (!location.startsWith('/reset-password') || !!registration_return_uri);
  const {
    useAuth,
    useError
  } = useMemo(() => {
    if (isStandalone) {
      return {
        useAuth: useStandaloneAuth,
        useError: useDefaultError
      };
    }
    return hookByApp[app] ?? hookByApp.default;
  }, [app, isStandalone]);
  const authHook = useAuth();
  const errorHook = useError();
  const partner = useMemo(() => {
    if (partners) {
      const partner = partners[pId];
      if (partner) {
        return partner;
      }
    }
    return {
      displayName: '',
      website: '',
      type: ''
    };
  }, [pId, partners]);
  return {
    ...authHook,
    ...errorHook,
    displayActionBarHeader: getDisplayActionBarHeader(app, isStandalone ? standaloneReturnUri : undefined),
    partner
  };
};
export default usePartner;